import { DataField } from "./DataField"

export default function ProfileTab({ loan }) {

    
    const loanData = loan?.data[0]
    const dob = new Date(loanData?.applicant?.dob)

    const applicant = loanData?.applicant || loanData.reapplicant

    return (
        <div>
            <div className="">
                <div className="grid grid-cols-2 gap-4">
                    <DataField
                        label={"First Name"}
                        value={applicant?.first_name
                            ? applicant?.first_name
                            : 'Not Provided'}
                    />
                    <DataField
                        label={"Middle Name"}
                        value={applicant?.middle_name
                            ? applicant?.middle_name
                            : 'Not Provided'}
                    />
                    <DataField
                        label={"Surname"}
                        value={applicant?.surname
                            ? applicant?.surname
                            : 'Not Provided'}
                    />
                    <DataField
                        label={"Address"}
                        value={applicant?.address
                            ? applicant?.address
                            : 'Not Provided'}
                    />
                    <DataField
                        label={"Email"}
                        value={applicant?.email
                            ? <span className="lowercase">{applicant?.email}</span>
                            : 'Not Provided'}
                    />
                     <DataField
                        label={"NIN"}
                        value={applicant?.nin
                            ? <span className="lowercase">{applicant?.nin}</span>
                            : 'Pending Verification'}
                    />
                    <DataField
                        label={"Phone"}
                        value={applicant?.phone
                            ? applicant?.phone
                            : 'Not Provided'}
                    />
                    <DataField
                        label={"LGA"}
                        value={applicant?.lga
                            ? applicant?.lga
                            : 'Not Provided'}
                    />
                    <DataField
                        label={"Gender"}
                        value={applicant?.gender
                            ? applicant?.gender
                            : 'Not Provided'}
                    />
                    <DataField
                        label={"Employment Status"}
                        value={applicant?.employment_status
                            ? applicant?.employment_status
                            : 'Not Provided'}
                    />
                    <DataField
                        label={"Hometown "}
                        value={applicant?.hometown
                            ? applicant?.hometown
                            : 'Not Provided'}
                    /><DataField
                        label={"Date of Birth"}
                        value={applicant?.dob
                            ? `${dob.getDate()}/${dob.getMonth() + 1
                            }/${dob.getFullYear()}`
                            : 'Not Provided'}
                    />
                </div>
            </div>
        </div>
    )
}